var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4323 8.11972L1.71844 0.405617C1.45231 0.284763 1.13474 0.356761 0.949603 0.585613C0.85901 0.696464 0.808248 0.834517 0.805451 0.977651C0.802653 1.12078 0.847982 1.26072 0.934175 1.37502L6.43047 8.70342L0.934175 16.0318C0.756751 16.2671 0.763179 16.5937 0.948317 16.8212C1.07303 16.9768 1.25945 17.0604 1.44845 17.0604C1.53973 17.0604 1.63102 17.0411 1.71716 17.0012L18.431 9.28712C18.6599 9.18169 18.8052 8.95413 18.8052 8.70342C18.8052 8.45271 18.6599 8.22514 18.4323 8.11972Z",
    fill: "#808080",
    fillOpacity: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.fcb8381d7905c8b2f75711c3e9a69e32.svg";
export { ForwardRef as ReactComponent };